import { render, staticRenderFns } from "./Beneficiary.vue?vue&type=template&id=48d62e25&scoped=true&"
import script from "./Beneficiary.vue?vue&type=script&lang=js&"
export * from "./Beneficiary.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=48d62e25&scoped=true&lang=css&"
import style1 from "./Beneficiary.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Beneficiary.vue?vue&type=style&index=2&id=48d62e25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d62e25",
  null
  
)

export default component.exports